import * as React from 'react';

import { StatsigProvider } from '@coursera-web/statsig';

import UnifiedUserExperienceHandler from 'bundles/unified-common/providers/UnifiedUserExperienceHandler';
import EnterpriseOrgUserExperienceDataProvider from 'bundles/unified-home-common/providers/org-scoped/data/EnterpriseOrgUserExperienceDataProvider';
import OrgScopedImpersonationDataProvider from 'bundles/unified-home-common/providers/org-scoped/data/OrgScopedImpersonationDataProvider';

/**
 * Org-scoped user experience handler: redirect + hold-render (UnifiedUserExperienceHandler)
 * plus org user experience data (EnterpriseOrgUserExperienceDataProvider).
 * Must be rendered inside a provider that supplies ThirdPartyOrganizationContext
 * (e.g. EnterpriseOrgHomePageProvider).
 */
const EnterpriseOrgUserExperienceHandler = ({ children }: React.PropsWithChildren<{}>) => {
  return (
    <StatsigProvider>
      {/*
        Reaching an org-scoped XDP already means EnterprisePageGuard's own rollout-gate-or-override-org
        check passed, so UnifiedUserExperienceHandler doesn't need to re-check the raw Statsig gate here.
        Without this, override orgs (whose gate value can legitimately differ from what
        EnterprisePageGuard saw moments earlier) never get their membership data fetched.
      */}
      <UnifiedUserExperienceHandler assumeOrgScopedEligible>
        <OrgScopedImpersonationDataProvider>
          <EnterpriseOrgUserExperienceDataProvider>{children}</EnterpriseOrgUserExperienceDataProvider>
        </OrgScopedImpersonationDataProvider>
      </UnifiedUserExperienceHandler>
    </StatsigProvider>
  );
};

export default EnterpriseOrgUserExperienceHandler;
